import React, { useState } from "react";
import emailjs from "emailjs-com";
import { FiInstagram, FiFacebook, FiLinkedin, FiMail } from "react-icons/fi";

const Contact = () => {
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });
  const [status, setStatus] = useState(null);

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("sending");

    const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID;
    const templateId = process.env.REACT_APP_EMAILJS_CONTACT_TEMPLATE_ID;
    const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

    if (!serviceId || !templateId || !publicKey) {
      console.warn("EmailJS env vars not set — contact form can't send yet.");
      setStatus("error");
      return;
    }

    try {
      await emailjs.send(serviceId, templateId, formData, publicKey);
      setStatus("success");
      setFormData({ name: "", email: "", message: "" });
    } catch (err) {
      console.warn("Contact message failed to send:", err);
      setStatus("error");
    }
  };

  return (
    <section className="bg-paper py-16 lg:py-24">
      <div className="max-w-content mx-auto grid grid-cols-1 gap-12 px-6 lg:grid-cols-2 lg:gap-16 lg:px-10">
        <div>
          <h2 className="text-3xl font-bold text-brand sm:text-4xl">Contact us</h2>
          <p className="mt-4 max-w-prose text-muted">
            Questions, partnership interest, or anything that isn't a
            booking — reach us here. Looking to book a birthday? Use the
            quote form instead.
          </p>

          <div className="mt-8 space-y-3 text-sm">
            <a href="mailto:info@nirkana.com" className="flex items-center gap-2 text-muted hover:text-charcoal">
              <FiMail size={16} /> info@nirkana.com
            </a>
          </div>

          <div className="mt-6 flex gap-4 text-muted">
            <a href="https://instagram.com/nirkanagroups" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="hover:text-charcoal">
              <FiInstagram size={20} />
            </a>
            <a href="https://facebook.com/nirkanagroup" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="hover:text-charcoal">
              <FiFacebook size={20} />
            </a>
            <button type="button" aria-label="LinkedIn (coming soon)" disabled className="hover:text-charcoal cursor-not-allowed opacity-60">
              <FiLinkedin size={20} />
            </button>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="rounded-2xl bg-cloud p-6 sm:p-8">
          {status === "success" && (
            <div className="mb-5 rounded-lg bg-success/10 px-4 py-3 text-sm text-charcoal">
              Message sent — we'll reply soon.
            </div>
          )}
          {status === "error" && (
            <div className="mb-5 rounded-lg bg-error/10 px-4 py-3 text-sm text-charcoal">
              Couldn't send that. Try again or email us directly.
            </div>
          )}
          <div className="space-y-4">
            <input
              type="text" name="name" required placeholder="Your name"
              value={formData.name} onChange={handleChange}
              className="w-full rounded-lg border border-line px-4 py-3 text-charcoal placeholder:text-muted focus:border-action"
            />
            <input
              type="email" name="email" required placeholder="Your email"
              value={formData.email} onChange={handleChange}
              className="w-full rounded-lg border border-line px-4 py-3 text-charcoal placeholder:text-muted focus:border-action"
            />
            <textarea
              name="message" required rows="4" placeholder="Your message"
              value={formData.message} onChange={handleChange}
              className="w-full rounded-lg border border-line px-4 py-3 text-charcoal placeholder:text-muted focus:border-action"
            />
          </div>
          <button
            type="submit"
            disabled={status === "sending"}
            className="mt-6 w-full rounded-full bg-brand px-6 py-3.5 text-base font-medium text-paper hover:bg-brand/90 transition-colors disabled:opacity-60"
          >
            {status === "sending" ? "Sending..." : "Send message"}
          </button>
        </form>
      </div>
    </section>
  );
};

export default Contact;
